import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },

  overrideWrap: {
    flexWrap: 'unset',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  blueIcon: {
    backgroundColor: '#176AE6 !important',
  },

  yellowIcon: {
    backgroundColor: '#f0c24e !important',
  },

  greenIcon: {
    backgroundColor: '#2DCE98 !important',
  },
}));
